import ProposePlanForm from "./ProposePlanForm";

export default function ProposePlanModal({ initial, onClose, onSent }) {
  return (
    <div data-testid="propose-plan-modal" className="fixed inset-0 z-[80] flex items-start justify-center overflow-y-auto bg-[#1e3d3a]/45 backdrop-blur-sm p-4 sm:p-8" onClick={onClose}>
      <div className="w-full max-w-3xl mt-6" onClick={(e) => e.stopPropagation()}>
        <ProposePlanForm initial={initial} onClose={onClose} onSent={() => { onSent?.(); onClose(); }} />
      </div>
    </div>
  );
}
